// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, first, forSalePropertyTypes, forSaleStatuses, keywords, last, maxBeds, maxPrice, minBeds, minPrice, offMlsOnly, sortOrder, useForSaleInventory) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    first: first,
    forSalePropertyTypes: forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    keywords: keywords,
    last: last,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    offMlsOnly: offMlsOnly,
    sortOrder: sortOrder,
    useForSaleInventory: useForSaleInventory
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function forSalePropertyV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "UNDER_CONTRACT" || $$enum === "SOLD") {
    return $$enum;
  }
}

let forSalePropertyV5FilterableStatus_fromString = forSalePropertyV5FilterableStatus_decode;

function propertySearchSortOrder_decode($$enum) {
  if ($$enum === "RECENTLY_BROADCAST" || $$enum === "RECENTLY_UPDATED_EXCLUDING_RENEWALS" || $$enum === "RECENTLY_UPDATED") {
    return $$enum;
  }
}

let propertySearchSortOrder_fromString = propertySearchSortOrder_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: propertySearchSortOrder_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSalePropertyTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSaleStatuses"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxBeds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minBeds"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offMlsOnly"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrder"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useForSaleInventory"
},
v15 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v16 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v17 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v18 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v27 = [
  (v23/*: any*/),
  (v24/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "halfBaths",
    "storageKey": null
  },
  (v25/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "livingArea",
    "storageKey": null
  },
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfUnits",
  "storageKey": null
},
v29 = [
  (v23/*: any*/),
  (v24/*: any*/)
],
v30 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v31 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v30/*: any*/),
            (v31/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "urlWithRing",
          "args": [
            (v30/*: any*/),
            {
              "kind": "Literal",
              "name": "ring",
              "value": true
            },
            (v31/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v32/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityRule",
  "storageKey": null
},
v36 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v37 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "crop",
      "value": false
    },
    {
      "kind": "Literal",
      "name": "embed",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "height",
      "value": 468
    },
    (v30/*: any*/),
    {
      "kind": "Literal",
      "name": "width",
      "value": 648
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "kind": "InlineFragment",
  "selections": (v42/*: any*/),
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v43/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        (v35/*: any*/)
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "broadcastAt",
  "storageKey": null
},
v47 = [
  (v22/*: any*/),
  (v33/*: any*/)
],
v48 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v49 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPropertyPrice"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "minPrice",
          "plural": false,
          "selections": (v48/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "maxPrice",
          "plural": false,
          "selections": (v48/*: any*/),
          "storageKey": null
        }
      ],
      "type": "PriceRange",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "format",
                  "value": "FULL"
                }
              ],
              "kind": "ScalarField",
              "name": "formatted",
              "storageKey": "formatted(format:\"FULL\")"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ExactPrice",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/)
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developer",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedCompletion",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v54 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageAttachment",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v38/*: any*/),
      (v37/*: any*/),
      (v33/*: any*/),
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  (v39/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v43/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v42/*: any*/),
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelayInventoryRefetchQuery",
    "selections": [
      {
        "args": [
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayInventory_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertiesPageRelayInventoryRefetchQuery",
    "selections": [
      {
        "condition": "useForSaleInventory",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v15/*: any*/),
              {
                "kind": "Variable",
                "name": "areaIds",
                "variableName": "areaIds"
              },
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "Variable",
                "name": "keywords",
                "variableName": "keywords"
              },
              (v18/*: any*/),
              {
                "kind": "Variable",
                "name": "maxBeds",
                "variableName": "maxBeds"
              },
              {
                "kind": "Variable",
                "name": "maxPrice",
                "variableName": "maxPrice"
              },
              {
                "kind": "Variable",
                "name": "minBeds",
                "variableName": "minBeds"
              },
              {
                "kind": "Variable",
                "name": "minPrice",
                "variableName": "minPrice"
              },
              {
                "kind": "Variable",
                "name": "offMlsOnly",
                "variableName": "offMlsOnly"
              },
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "forSalePropertyTypes"
              },
              {
                "kind": "Variable",
                "name": "sortOrder",
                "variableName": "sortOrder"
              },
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "forSaleStatuses"
              }
            ],
            "concreteType": "ForSaleInventoryConnection",
            "kind": "LinkedField",
            "name": "searchForSaleInventory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSaleInventoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "propertyType",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "CondoProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "SingleFamilyProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v25/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "type": "LotProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "type": "MultiUnitProperty",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "propertyType",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "CondoProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "SingleFamilyProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/)
                                ],
                                "type": "MultiUnitProperty",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "agentV2",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "type": "VisibleForSalePropertyAgent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v32/*: any*/)
                                ],
                                "type": "AnonymousForSalePropertyAgent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": (v36/*: any*/),
                                "concreteType": "PropertyImageConnection",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PropertyImageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ImageAttachment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v33/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v39/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v40/*: any*/)
                                ],
                                "storageKey": "images(first:1)"
                              },
                              {
                                "alias": null,
                                "args": (v36/*: any*/),
                                "filters": null,
                                "handle": "connection",
                                "key": "PropertySearchCard_images",
                                "kind": "LinkedHandle",
                                "name": "images"
                              },
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "mlsPlan",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "onMlsAt",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ListOnMlsAsActive",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "activeOnMlsOn",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ListOnMlsAsComingSoon",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "activeOnMlsSince",
                                "storageKey": null
                              },
                              (v44/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "agentV2Id",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "agentV2",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Agent",
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": (v47/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "VisibleForSalePropertyAgent",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "type": "ForSalePropertyV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "agentId",
                                    "args": null,
                                    "concreteType": "Agent",
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": (v47/*: any*/),
                                    "storageKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "type": "RentalPropertyV5",
                                "abstractKey": null
                              }
                            ],
                            "type": "PropertyV5",
                            "abstractKey": "__isPropertyV5"
                          }
                        ],
                        "type": "ForSalePropertyV5",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitType",
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevelopmentProject",
                            "kind": "LinkedField",
                            "name": "development",
                            "plural": false,
                            "selections": [
                              (v51/*: any*/),
                              (v52/*: any*/),
                              (v33/*: any*/),
                              (v22/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v33/*: any*/),
                          {
                            "alias": "unitImages",
                            "args": (v36/*: any*/),
                            "concreteType": "DevelopmentProjectSampleUnitImageConnection",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProjectSampleUnitImageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v54/*: any*/),
                                "storageKey": null
                              },
                              (v40/*: any*/)
                            ],
                            "storageKey": "images(first:1)"
                          },
                          {
                            "alias": "unitImages",
                            "args": (v36/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "DevelopmentUnitSearchResultCard__unitImages",
                            "kind": "LinkedHandle",
                            "name": "images"
                          },
                          (v53/*: any*/),
                          (v55/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "beds",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/)
                                ],
                                "type": "DevelopmentProjectUnitExactBeds",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minBeds",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxBeds",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitBedsRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "baths",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "type": "DevelopmentProjectUnitExactBaths",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minBaths",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxBaths",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitBathsRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "squareFeet",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "squareFeet",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitExactSquareFeet",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minSquareFeet",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxSquareFeet",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitSquareFeetRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ],
                        "type": "DevelopmentProjectSampleUnit",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          (v51/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalProjectUnits",
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          (v49/*: any*/),
                          (v33/*: any*/),
                          {
                            "alias": "projectImages",
                            "args": (v36/*: any*/),
                            "concreteType": "DevelopmentProjectImageConnection",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProjectImageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v54/*: any*/),
                                "storageKey": null
                              },
                              (v40/*: any*/)
                            ],
                            "storageKey": "images(first:1)"
                          },
                          {
                            "alias": "projectImages",
                            "args": (v36/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "DevelopmentProjectSearchResultCard__projectImages",
                            "kind": "LinkedHandle",
                            "name": "images"
                          },
                          (v53/*: any*/),
                          (v55/*: any*/),
                          (v34/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ],
                        "type": "DevelopmentProject",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v33/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "755e505ca68c3eb5c2467d6e4636b916",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelayInventoryRefetchQuery",
    "operationKind": "query",
    "text": "query PropertiesPageRelayInventoryRefetchQuery(\n  $after: String\n  $areaIds: [ID!]!\n  $before: String\n  $first: Int\n  $forSalePropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $forSaleStatuses: [ForSalePropertyV5FilterableStatus!]\n  $keywords: [String!]\n  $last: Int\n  $maxBeds: Int\n  $maxPrice: Int\n  $minBeds: Int\n  $minPrice: Int\n  $offMlsOnly: Boolean\n  $sortOrder: PropertySearchSortOrder\n  $useForSaleInventory: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...PropertiesPageRelayInventory_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AnonymousAgentInfoForSaleProperty_anonymousForSalePropertyAgent on AnonymousForSalePropertyAgent {\n  membershipStatus\n}\n\nfragment DevelopmentProjectSearchResultActions_developmentProject on DevelopmentProject {\n  id\n}\n\nfragment DevelopmentProjectSearchResultAgent_developmentProject on DevelopmentProject {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment DevelopmentProjectSearchResultCard_developmentProject on DevelopmentProject {\n  id\n  nodeId\n  projectImages: images(first: 1) {\n    edges {\n      node {\n        key\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DevelopmentProjectSearchResultTimestamp_developmentProject on DevelopmentProject {\n  updatedAt\n  broadcastAt\n}\n\nfragment DevelopmentProjectSearchResultTitleAndLocation_developmentProject on DevelopmentProject {\n  name\n  location {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n    }\n  }\n}\n\nfragment DevelopmentProjectSearchResult_developmentProject on DevelopmentProject {\n  developer\n  totalProjectUnits\n  estimatedCompletion\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n  ...DevelopmentProjectSearchResultCard_developmentProject\n  ...DevelopmentProjectSearchResultTitleAndLocation_developmentProject\n  ...DevelopmentProjectSearchResultAgent_developmentProject\n  ...DevelopmentProjectSearchResultTimestamp_developmentProject\n  ...DevelopmentProjectSearchResultActions_developmentProject\n}\n\nfragment DevelopmentUnitSearchResultActions_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  id\n  development {\n    id\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  beds {\n    __typename\n    ... on DevelopmentProjectUnitExactBeds {\n      beds\n    }\n    ... on DevelopmentProjectUnitBedsRange {\n      minBeds\n      maxBeds\n    }\n  }\n  baths {\n    __typename\n    ... on DevelopmentProjectUnitExactBaths {\n      baths\n    }\n    ... on DevelopmentProjectUnitBathsRange {\n      minBaths\n      maxBaths\n    }\n  }\n  squareFeet {\n    __typename\n    ... on DevelopmentProjectUnitExactSquareFeet {\n      squareFeet\n    }\n    ... on DevelopmentProjectUnitSquareFeetRange {\n      minSquareFeet\n      maxSquareFeet\n    }\n  }\n}\n\nfragment DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  id\n  nodeId\n  development {\n    id\n    nodeId\n  }\n  unitImages: images(first: 1) {\n    edges {\n      node {\n        key\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DevelopmentUnitSearchResultTimestamp_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  updatedAt\n  broadcastAt\n}\n\nfragment DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  unitType\n  name\n  location {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n    }\n  }\n  development {\n    name\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResult_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  unitType\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n  development {\n    developer\n    estimatedCompletion\n    nodeId\n  }\n  ...DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultTimestamp_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultActions_newDevelopmentSampleUnit\n}\n\nfragment ForSalePropertyAttributesCondo_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributesLot_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment ForSalePropertyAttributesMultiUnit_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment ForSalePropertyAttributesSingleFamily_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...ForSalePropertyAttributesCondo_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...ForSalePropertyAttributesSingleFamily_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...ForSalePropertyAttributesLot_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...ForSalePropertyAttributesMultiUnit_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_Agent_forSalePropertyV5 on ForSalePropertyV5 {\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        ...AgentInfo_agent\n        ...OwnAnonymousAgentInfo_agent\n        nodeId\n      }\n      visibilityRule\n    }\n    ... on AnonymousForSalePropertyAgent {\n      ...AnonymousAgentInfoForSaleProperty_anonymousForSalePropertyAgent\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_StatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertySearchResultCard_propertyV5\n  ...ForSalePropertySearchResult_StatusLabel_forSalePropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertiesSearchMapListPropertyLocation_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...ForSalePropertyAttributes_property\n  ...PropertiesSearchMapListPropertyAttributes_forSaleProperty\n  ...ForSalePropertySearchResult_Agent_forSalePropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment OwnAnonymousAgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment PropertiesPageRelayInventory_query_pbnwq on Query {\n  searchForSaleInventory(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $useForSaleInventory) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on ForSalePropertyV5 {\n          id\n          ...ForSalePropertySearchResult_forSalePropertyV5\n        }\n        ... on DevelopmentProjectSampleUnit {\n          id\n          ...DevelopmentUnitSearchResult_newDevelopmentSampleUnit\n        }\n        ... on DevelopmentProject {\n          id\n          ...DevelopmentProjectSearchResult_developmentProject\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment PropertiesSearchMapListPropertyAttributes_forSaleProperty on ForSalePropertyV5 {\n  ...ForSalePropertyAttributes_property\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      beds\n      baths\n    }\n    ... on SingleFamilyProperty {\n      beds\n      baths\n    }\n    ... on MultiUnitProperty {\n      numberOfUnits\n    }\n    ... on LotProperty {\n      __typename\n    }\n  }\n}\n\nfragment PropertiesSearchMapListPropertyLocation_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on AlreadyOnMls {\n      __typename\n    }\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPrice_price_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n}\n\nfragment PropertyPrice_propertyPrice_1tj01C on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: SHORT)\n    }\n    maxPrice {\n      formatted(format: SHORT)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyPrice_property_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n}\n\nfragment PropertySearchResultActions_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  id\n  ... on ForSalePropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n}\n\nfragment PropertySearchResultCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        key\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n  nodeId\n}\n\nfragment PropertySearchResultTimestamp_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  updatedAt\n  broadcastAt\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
